import { baseApi } from "./baseApi";
const WAREHOUSE_ALLOCATION_BASE_URL = "/warehouse-allocation";

export const warehouseAllocationApi = baseApi.injectEndpoints({
  tagTypes: ["WarehouseAllocation"],

  endpoints: (build) => ({
    addWarehouseAllocation: build.mutation({
      query: (body) => ({
        url: WAREHOUSE_ALLOCATION_BASE_URL,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "WarehouseAllocation", id: "LIST" }],
    }),
    listWarehouseAllocation: build.query({
      query: (params) => ({
        url: WAREHOUSE_ALLOCATION_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.invalidatesTags
          ? [
              ...result?.data?.map(({ _id }) => ({
                type: "WarehouseAllocation",
                // id: _id,
              })),
              { type: "WarehouseAllocation", id: "LIST" },
            ]
          : [{ TYPE: "WarehouseAllocation", id: "LIST" }],
    }),
    getDDLWarehouseAllocationList: build.query({
      query: (params) => ({
        url: `${WAREHOUSE_ALLOCATION_BASE_URL}/ddl`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({
                type: "WarehouseAllocation",
                id,
              })),
              { type: "WarehouseAllocation", id: "DDL" },
            ]
          : [{ type: "WarehouseAllocation", id: "DDL" }],
    }),

    getWarehouseAllocationDetail: build.query({
      query: (allocationId) =>
        `${WAREHOUSE_ALLOCATION_BASE_URL}/${allocationId}`,
      providesTags: (result, error, { _id }) => [
        { type: "WarehouseAllocation", id: _id },
        { type: "WarehouseAllocation", id: "LIST" },
      ],
    }),
    updateWarehouseAllocation: build.mutation({
      query: ({ _id, ...body }) => ({
        url: `${WAREHOUSE_ALLOCATION_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { _id: id }) => [
        { type: "WarehouseAllocation", id },
        { type: "WarehouseAllocation", id: "LIST" },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useListWarehouseAllocationQuery,
  useLazyListWarehouseAllocationQuery,
  useAddWarehouseAllocationMutation,
  useLazyGetDDLWarehouseAllocationListQuery,
  useGetWarehouseAllocationDetailQuery,
  useUpdateWarehouseAllocationMutation,
} = warehouseAllocationApi;
